import {usePageContext} from '~/components'

// We need custom Apex config to allow the user to select a single series point on the graph.

let isZooming = false

export const useCustomApexOptions = () => {
	const {setSelectedSeriesPointIndex} = usePageContext()

	return {
		chart: {
			events: {
				beforeResetZoom: graphContext => {
					const lastSeriesPointIndex = graphContext.w.globals.dataPoints - 1
					// We want the reset button to reset the AggregatesHeader to last month in addition to resetting the graph
					setSelectedSeriesPointIndex(lastSeriesPointIndex)
				},
				beforeZoom: (graphContext, {xaxis}) => {
					// We have to block the click event when zooming to prevent the AggregatesHeader from being changed on zooming through selection
					isZooming = true

					const {min, max} = xaxis
					const {initialMinX, initialMaxX} = graphContext.w.globals

					if (min < initialMinX || max > initialMaxX) return {xaxis: {min: initialMinX, max: initialMaxX}}
				},
				click: (event, graphContext, opts) => {
					const {dataPointIndex: seriesPointIndex} = opts
					const hasSeriesPoint = seriesPointIndex !== null && seriesPointIndex !== undefined

					hasSeriesPoint && !isZooming && setSelectedSeriesPointIndex(seriesPointIndex)
					isZooming = false
				},
			},
		},
	}
}
